import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Awaiting Approval',
      type: 'metric',
      content: {
        '{}': {
          name: 'Awaiting Approval',
          value: {
            '{}': {
              quality: 'neutral',
              tooltip:
                "The requirement's spec has no merged approval pull request yet.",
              emphasis: {
                'fmt.num': [
                  {
                    '#': {
                      '@': 'awaitingApprovalRequirements',
                    },
                  },
                  {
                    ',': true,
                    '.': {
                      always: 0,
                    },
                  },
                ],
              },
            },
          },
          description: 'Requirements whose spec is not yet approved.',
        },
      },
    },
  },
  subqueries: {
    awaitingApprovalRequirements: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@': 'specApprovedAt',
              },
              null,
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
        specApprovedAt: {
          ref: {
            attr: 'attr:ent#!requirements#!requirement:!spec',
          },
          target: 'ent:!specs:!spec',
          quantity: 1,
          selection: {
            '@': 'approvalMergedAt',
          },
          subqueries: {
            approvalMergedAt: {
              ref: {
                attr: 'attr:ent#!specs#!spec:!approval_pull_request',
              },
              target: 'ent:!pull_requests:!pull_request',
              selection: {
                '@.': '!merged_at',
              },
            },
          },
        },
      },
    },
  },
}
